angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('de_DE', {});
/* jshint +W100 */
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./src/po/de_DE.po
 ** module id = 362
 ** module chunks = 0
 **/